module.exports = __webpack_public_path__ + "img/img1.f0f152ae.jpg";